module.exports = __webpack_public_path__ + "fonts/Montserrat-VariableFont_wght.52a37115.ttf";